<div *ngIf="control.invalid" class="text-red fw-bold mb-4">
    <div *ngIf="control.errors?.['error']">
        {{ control.errors["error"]["message"] }}
    </div>
</div>
